import * as React from 'react'

import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import TextField from '@material-ui/core/TextField'

import './style.scss'

interface IProps {
  label: string
  input: any
  type?: string
  placeholder?: string
  multiline?: boolean
  rows?: number
  onBlur: () => void
  meta?: any
}

export const Input = (props: IProps) => {
  let { type } = props
  const { onBlur } = props

  const {
    input,
    label,
    placeholder,
    multiline,
    rows,
    meta: { invalid, error, visited }
  } = props

  const [isFocus, setFocus] = React.useState(false)

  if (!type) {
    type = 'text'
  }

  const onBlurLocal = () => {
    if (onBlur) {
      onBlur()
    }

    setFocus(false)
  }

  return (
    <FormControl
      className={
        isFocus
          ? 'input-form-control text-fiel focus-style'
          : 'input-form-control text-field'
      }
      onFocus={() => setFocus(true)}
      onBlur={onBlurLocal}
    >
      <TextField
        id={`${input.name}-field`}
        className="text-field"
        type={type}
        label={label}
        name={input.name}
        placeholder={placeholder ? placeholder : null}
        multiline={multiline}
        margin="normal"
        rows={rows ? rows : null}
        InputProps={{
          className: 'input',
          autoComplete: 'new-password'
        }}
        InputLabelProps={
          type === 'date' || (label && placeholder)
            ? {
                shrink: true
              }
            : null
        }
        {...input}
      />
      {invalid && visited && input.value && input.value.length > 1 && (
        <FormHelperText id={`${input.name}-field`} className="error-message">
          {error}
        </FormHelperText>
      )}
    </FormControl>
  )
}



// WEBPACK FOOTER //
// ./src/components/Input/index.tsx